import { ReactElement } from 'react';
import UUID from '@ax2/common/model/UUID';
import AnswerData from '@ax2/common/model/answers-data/AnswerData';
import QuestionSchema from '@ax2/common/model/schemas/QuestionSchema';
import QuestionType from '@ax2/common/model/QuestionType';
import { getQuestion } from './questionByTypeConverter';
import { getValidation } from './validationByTypeConverter';
import { sortByOrderAndType } from '@ax2/common/helpers/sort';

export interface QuestionBuilder {
  id: UUID;
  questionType: QuestionType;
  getQuestion: (
    data: AnswerData | undefined,
    onCompletion: (data: AnswerData | undefined) => void
  ) => ReactElement;
  getRequiredValidation: (data: AnswerData | undefined) => string | null;
}

export function getQuestionBuilder(
  schema: QuestionSchema,
  isDesktop: boolean,
  number: string
): QuestionBuilder {
  const qSchema = prepareQuestion(schema);
  const builder = (
    data: AnswerData | undefined,
    onCompletion: (data: AnswerData | undefined) => void
  ) => getQuestion(qSchema, isDesktop, number, data, onCompletion);
  const validation = (data: AnswerData | undefined) =>
    qSchema.isRequired ? getValidation(qSchema, isDesktop, data) : null;
  return {
    id: qSchema.id,
    questionType: qSchema.questionType,
    getQuestion: builder,
    getRequiredValidation: validation,
  };
}

function prepareQuestion(qSchema: QuestionSchema): QuestionSchema {
  if ('answerOptions' in qSchema) {
    return Object.assign({}, qSchema, {
      answerOptions: sortByOrderAndType(
        qSchema.answerOptions,
        qSchema.randomize
      ),
    });
  } else if ('columns' in qSchema && 'rows' in qSchema) {
    return Object.assign({}, qSchema, {
      columns: sortByOrderAndType(qSchema.columns, qSchema.randomizeColumn),
      rows: sortByOrderAndType(qSchema.rows, qSchema.randomizeRow),
    });
  } else {
    return qSchema;
  }
}
